export enum ReactivationPeriodOfDayEnum {
  MORNING = "MORNING",
  AFTERNOON = "AFTERNOON",
}
